import Swiper from 'swiper'

const moduleName = 'tech-s'

module.exports = () => {
  const sliderEl = document.querySelector('.js-tech-s')

  if (!sliderEl) return;

  let techSlider = null

  function init () {

    techSlider = new Swiper('.js-tech-s', {
      slidesPerView: 2,
      spaceBetween: 60,
      watchOverflow: true,
      pagination: {
        el: '.tech-s__pagination'
      },
      breakpoints: {
        1280: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        1023: {
          slidesPerView: 1,
          spaceBetween: 65
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 16
        }
      }
    })
  }

  init ()
}